import { bscMainnet } from './bscMainnet';
import { bscTestnet } from './bscTestnet';
import { ethereum } from './ethereum';
import { sepolia } from './sepolia';
import { arbitrumOne } from './arbitrumOne';
import { arbitrumSepolia } from './arbitrumSepolia';
import { baseMainnet } from './baseMainnet';
import { baseSepolia } from './baseSepolia';
import { opBnbMainnet } from './opBnbMainnet';
import { opBnbTestnet } from './opBnbTestnet';
import { optimismMainnet } from './optimismMainnet';
import { optimismSepolia } from './optimismSepolia';
import { zkSyncMainnet } from './zkSyncMainnet';
import { zkSyncSepolia } from './zkSyncSepolia';
import { unichainMainnet } from './unichainMainnet';
import { unichainSepolia } from './unichainSepolia';
import { ChainId, type VToken } from '../../types';

export const vTokens: {
  [chainId in ChainId]: VToken[];
} = {
  [56]: bscMainnet,
  [97]: bscTestnet,
  [1]: ethereum,
  [11155111]: sepolia,
  [42161]: arbitrumOne,
  [421614]: arbitrumSepolia,
  [8453]: baseMainnet,
  [84532]: baseSepolia,
  [204]: opBnbMainnet,
  [5611]: opBnbTestnet,
  [10]: optimismMainnet,
  [11155420]: optimismSepolia,
  [324]: zkSyncMainnet,
  [300]: zkSyncSepolia,
  [130]: unichainMainnet,
  [1301]: unichainSepolia,
};
